import { PageHeaderLayout, RouteTabWithContent, TabContent } from "@homebound/beam";
import { useMemo } from "react";
import { useMatch } from "react-router-dom";
import { CreateOrUpdateDevelopmentModal } from "src/routes/developments/components/CreateOrUpdateDevelopmentModal";
import { DevelopmentsPage } from "src/routes/developments/DevelopmentsPage";
import { ProjectsPage } from "src/routes/projects/ProjectsPage";
import { developmentsRoute, projectsRoute } from "src/routing/domains/projectsPaths";

export function ProjectsDevelopmentsPage() {
  const isDevelopmentsPage = useMatch({ path: developmentsRoute.path, end: true });

  const tabs: RouteTabWithContent[] = useMemo(
    () => [
      { name: "All Projects", href: projectsRoute.url(), path: projectsRoute.path, render: () => <ProjectsPage /> },
      {
        name: "Developments",
        href: developmentsRoute.url(),
        path: [developmentsRoute.path],
        render: () => <DevelopmentsPage />,
      },
    ],
    [],
  );

  return (
    <PageHeaderLayout
      pageHeader={{
        title: isDevelopmentsPage ? "Developments" : "Projects",
        rightSlot: isDevelopmentsPage ? <CreateOrUpdateDevelopmentModal /> : undefined,
        tabs: { tabs },
      }}
    >
      <TabContent tabs={tabs} />
    </PageHeaderLayout>
  );
}
